import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=e22cf2d0&scoped=true&"
import script from "./FilterLabel.vue?vue&type=script&lang=ts&"
export * from "./FilterLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=e22cf2d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22cf2d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
